import SalesOrderLineInterface from '../interfaces/SalesOrderLineInterface';

export default class SalesOrderLine implements SalesOrderLineInterface {
  constructor(data: Partial<SalesOrderLine> = {}) {
    Object.assign(this, data);
  }

  DocumnetNo = '';
  Line_No = 0;
  Type = '';
  No = '';
  Item_No_2 = '';
  Description = '';
  Description2 = '';
  Quantity = '0';
  Quantity_Shipped = '0';
  Document_Type = '';
  LineNotes = '';
  Line_Notes = '';
  Search_Item_No_2 = '';
  Order_Date = '';
  Your_Reference = '';
  Instrastat_Om_Code = '';
  Coo = '';
  Custom_Value = '0.00';
  Item_Category_Code = '';
  Customs_Unit_Net_Weight_Grams = '0';
  Total_Amount = '0';
  External_Document_Line_No = 0;
  Qty_Spoil = '0.00';
  Nav_Only = false;
  Sold_as_SKU = '';
  Sold_As_Barcode = '';
  Sold_As_Description = '';
  Personalised = false;
  Product_URL_1 = '';
  Product_URL_2 = '';
  Product_URL_3 = '';
  Item = {
    Barcode: '',
  };
  Expanded = true;
  Line_To_Change = false;
}
